/**
 * Builds a connection display name from a base string, appending ` 2`, ` 3`, … when that name
 * (case-insensitive) is already used by another connection in the same scope.
 * @param baseName Preferred display name (e.g. toolkit or provider display name).
 * @param existingNames Names already taken by sibling connections.
 * @returns A unique display name between 1 and 100 characters.
 */
export function buildUniqueConnectionName(
  baseName: string,
  existingNames: readonly string[],
): string {
  const base = baseName.trim().slice(0, 100);
  if (!base) {
    return 'Connection';
  }
  const taken = new Set(
    existingNames.map((value) => value.trim().toLowerCase()).filter((value) => value.length > 0),
  );
  if (!taken.has(base.toLowerCase())) {
    return base;
  }
  let suffix = 2;
  while (taken.has(`${base} ${suffix}`.toLowerCase())) {
    suffix += 1;
  }
  const candidate = `${base} ${suffix}`;
  return candidate.length <= 100 ? candidate : candidate.slice(0, 100);
}
